import { useEffect } from "react";
import "./landing.css";
import { BODY_HTML } from "./landingBody";
import { initLanding } from "./landingScript";

import { API } from "@/apiBase";

export default function Landing() {
  useEffect(() => {
    const cleanup = initLanding(API);
    return () => { if (typeof cleanup === "function") cleanup(); };
  }, []);
  return <div data-testid="coach-landing" dangerouslySetInnerHTML={{ __html: BODY_HTML }} />;
}
